import React, { useEffect, useState } from 'react';
import { Slider, withFormikSupport } from '@fourthwall/components';
import { Label } from '../../components/Label/Label';
import * as S from './Range.styled';
export const RangeComponent = ({ data, value, onChange, onSettingUpdate }) => {
    const { id, label, min, max, step, value: initialValue, info, unit } = data;
    const [lastValue, setLastValue] = useState(initialValue);
    useEffect(() => {
        if (lastValue === initialValue)
            return;
        onSettingUpdate(id, lastValue, true);
    }, [lastValue]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Label, { info: info }, label),
        React.createElement(S.Container, null,
            React.createElement(S.SliderContainer, null,
                React.createElement(Slider, { min: min, max: max, step: step, value: value, onChange: (value) => {
                        onChange(value);
                    }, onChangeComplete: (value) => setLastValue(value) })),
            React.createElement(S.InputContainer, null,
                React.createElement(S.InputStyles, { type: "number", value: value, onChange: (e) => {
                        const newValue = Number(e.target.value);
                        onChange(newValue);
                    }, onBlur: (e) => {
                        let newValue = Number(e.target.value);
                        if (newValue < min)
                            newValue = min;
                        if (newValue > max)
                            newValue = max;
                        onChange(newValue);
                        setLastValue(newValue);
                    }, min: min, max: max }),
                React.createElement(S.Postfix, null, unit)))));
};
export const Range = withFormikSupport(RangeComponent);
